export const readFileAsBase64 = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Content = reader.result?.toString().split(",")[1];
      resolve({
        name: file.name,
        contentType: file.type,
        contentInBase64: base64Content,
      });
    };
    reader.onerror = (error) => reject(error);
  });
};

export const processFiles = async (uploadedFiles) => {
  const allFiles = await Promise.all(
    uploadedFiles.map((file) => readFileAsBase64(file))
  );
  return allFiles;
};
